import { RainfallStation } from "./types";

export function dedupeRainfallStations(
  stations: RainfallStation[],
): RainfallStation[] {
  if (!stations.length) {
    return [];
  }

  const result: RainfallStation[] = [];
  const seenCoordinates = new Set<string>();

  stations.forEach((station) => {
    const coordinateKey = `${station.lng.toFixed(5)}:${station.lat.toFixed(5)}`;
    if (seenCoordinates.has(coordinateKey)) {
      return;
    }

    seenCoordinates.add(coordinateKey);
    result.push({ ...station });
  });

  return result;
}
